<template>
    <div :class="{ relative: relative, 'no-relative': !relative, isOpen: isOpen && isIpad() }" class="editor-dropdown">
        <button
            @click="open"
            :style="handlerStyle"
            :class="{ 'editor-button_padding': !noPadding, active: isOpen || isActive }"
            class="editor-button editor-button_fill"
        >
            <slot name="handler"></slot>
            <DropdownChevronIcon
                :style="{ transform: isOpen ? 'rotate(180deg)' : 'none' }"
                width="6"
                height="5"
                style="margin-left: 4px"
                v-if="chevron"
                fill="#53595c"
            />
        </button>
        <div v-show="isOpen" class="editor-modal" :class="{ iPad: isIpad(), mobile: isMobile() }">
            <div :class="!hideScroll ? 'custom-scroll' : ''">
                <slot name="content"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import { getPersonalSettings, updatePersonalSettings } from "@common-store/personal-settings"
import { v4 } from "uuid"
import ClickOutside from "vue-click-outside"
import DropdownChevronIcon from "@icons/DropdownChevronIcon.vue"
import checkDevice from "@mixins/checkDevice"
import { EventBus } from "~events"

export default {
    components: { DropdownChevronIcon },
    props: {
        chevron: {
            type: Boolean,
            default: false
        },
        hideScroll: {
            type: Boolean,
            default: false
        },
        isChild: {
            type: Boolean,
            default: false
        },
        isActive: {
            type: Boolean,
            default: false
        },
        relative: {
            type: Boolean,
            default: true
        },
        noPadding: {
            type: Boolean,
            default: false
        },
        saveKey: {
            type: String,
            default: ""
        },
        handlerStyle: {
            type: Object,
            default: () => {}
        },
        editor: {
            type: Object,
            default: null
        }
    },
    directives: {
        ClickOutside
    },
    mixins: [checkDevice],
    name: "EditorDropdown",
    data() {
        return {
            isOpen: false,
            uuid: v4()
        }
    },
    created() {
        EventBus.$on("open-dropdown", uuid => {
            if (this.isOpen && uuid !== this.uuid) {
                this.hide()
            }
        })

        EventBus.$on("open-child-dropdown", uuid => {
            if (this.isChild && this.isOpen && uuid !== this.uuid) {
                this.hide()
            }
        })

        if (this.saveKey && getPersonalSettings(this.saveKey)) {
            //this.open()
        }
    },
    methods: {
        open() {
            if (this.editor && !this.isMobile()) {
                this.editor.chain().focus()
            }

            if (!this.isChild) {
                EventBus.$emit("open-dropdown", this.uuid)
            } else {
                EventBus.$emit("open-child-dropdown", this.uuid)
            }

            if (this.saveKey && getPersonalSettings(this.saveKey) !== !this.isOpen) {
                updatePersonalSettings(this.saveKey, !this.isOpen)
            }

            this.isOpen = !this.isOpen

            this.$nextTick(() => {
                const el = this.$el.querySelector(".editor-menu-item.active")
                if (el) {
                    const { offsetTop } = el
                    this.$el.querySelector(".custom-scroll").scrollTop = offsetTop - 10
                }
            })
        },
        hide() {
            this.isOpen = false
        }
    },
    watch: {
        isOpen(val) {
            this.$emit("handle:open", val)
        }
    }
}
</script>

<style lang="sass" scoped>
.editor-button
    display: flex
    align-items: center
.editor-dropdown
    transition: .2s
    &.l-25
        .editor-modal
            left: -25px
    &.right
        .editor-modal
            left: auto
            width: max-content
            padding: 10px
            right: -5px
        .custom-scroll
            overflow: visible
    &.l-18
        .editor-modal
            left: -18px
    &.l-16
        .editor-modal
            left: -16px
    &.min-150
        .custom-scroll
            min-width: 150px
.editor-modal
    position: absolute
    top: calc(100% + 4px)
    z-index: 99999999999999
    background: #fff
    border-bottom-left-radius: 6px
    border-bottom-right-radius: 6px
    border-top: 1px solid #d5d7d9
    left: -4px
    padding: 4px
    min-width: 100px
    transition: .2s
    .custom-scroll
        max-height: 215px
        overflow: auto
    &.iPad, &.mobile
        border-radius: 6px
        border: none
        .custom-scroll
            max-height: 125px
    &.iPad
        top: calc(-200% + 6px)
        z-index: 999
        filter: drop-shadow(0 2px 5px rgba(128, 158, 191, 0.25))
        .editor-menu-item
            height: 30px

        &::v-deep
            &:has(.simple-color-input)
                padding: 0

            .simple-color-input
                height: 0

            .input-circle
                width: 24px
                height: 24px

            .simple-color-modal
                border-radius: 6px
                bottom: calc(0% + 38px)
                left: 0
                top: auto
                max-width: 350px
                overflow: auto
                padding-bottom: 5px

            .simple-color-custom
                padding: 4px

            .input-circle-grid
                grid-template-columns: repeat(34, 1fr )
                grid-template-rows: 1fr
                margin: 8px
                grid-gap: 4px

            .simple-color-label
                margin-bottom: 10px
        .custom-scroll
            display: flex
            max-width: 350px
            padding-bottom: 2px

            .default-button_white
                min-width: 100px
                max-width: none
    &.mobile
        bottom: calc(100% + 5px)
        top: auto
        &::v-deep
            .simple-color-modal
                transform: translateY(-100%)
            .editor-modal
                filter: none
        .custom-scroll
            max-height: 175px
    .editor-menu-item
        font-size: 13px
        display: flex
        align-items: center
        font-weight: 400
        border-radius: 6px
        padding-left: 14px
        padding-right: 14px
        cursor: pointer
        height: 39px
        white-space: nowrap
        margin-bottom: 2px
        color: #151515
        background: #fff
        transition: .2s
        margin-right: 5px
        &:hover, &.active
            background: #F2F7FF
        svg
            fill: #53595c
    h1, h2, h3, h4, h5, h6
        height: auto !important
        min-height: 39px !important
        font-family: Inter, sans-serif
        line-height: 160%
        font-weight: 500
    &:not(&.iPad)
        h1
            font-size: 2.125rem !important
        h2
            font-size: 1.875rem !important
        h3
            font-size: 1.5rem !important
        h4
            font-size: 1.25rem !important
        h5
            font-size: 1.125rem !important
        h6
            font-size: 1rem !important
.no-relative
    .editor-modal
        top: 100%
        left: 0
</style>
